import { Colors, Icon, NumberTag } from '@gripp/shared-ui';
import {
  Platform,
  Pressable,
  StyleSheet,
  View
} from 'react-native';

export interface FilterHeadersProps {
  onSearchPress: () => void;
  onFilterPress: () => void;
  filterCount?: number;
  Routes: Record<string, string>;
}

export const FilterHeaders = ({
  onSearchPress,
  onFilterPress,
  filterCount,
  Routes
}: FilterHeadersProps) => {
  return (
    <View style={styles.iconButtonsContainer}>
      <Pressable
        onPress={onSearchPress}
        style={styles.iconButton}
      >
        <Icon name="Search" size={24} color={Colors.black} />
      </Pressable>
      <Pressable
        onPress={onFilterPress}
        style={styles.iconButton}
      >
        <View style={styles.filterIconContainer}>
          <Icon name="Filter" size={24} color={Colors.black} />
          {filterCount !== undefined && filterCount > 0 && (
            <View style={styles.badgeContainer}>
              <NumberTag number={filterCount} variant="black" />
            </View>
          )}
        </View>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  iconButtonsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  iconButton: {
    padding: 4,
    ...Platform.select({
      web: {
        padding: 8,
      },
    }),
  },
  filterIconContainer: {
    position: 'relative',
  },
  badgeContainer: {
    position: 'absolute',
    top: -6,
    right: -6,
  },
});
